import styles from './ErrorLine.module.scss';

const ErrorLine = () => {
  return <div className={styles.root}>Same error</div>
};

export default ErrorLine;